<template id="main-page">
  <v-ons-page>
    <v-ons-toolbar>
      <div class="center" style="font-size: 110%;font-weight: bold">{{nome_emit}}</div>
    </v-ons-toolbar>
     <v-ons-card>
    <div class="content">
    <v-ons-row>
    <v-ons-col width="70%"></v-ons-col>
    <v-ons-col> <v-ons-button style="font-size: 100%" class="btn btn-danger" @click="orcamento()"><i class="fas fa-plus"></i> Novo Orçamento</v-ons-button></v-ons-col>
    </v-ons-row>
    <v-ons-row style="font-size: 18px; font-weight: bold">
    <br>
    {{nome_emit}}
    </v-ons-row>
    <v-ons-row>
    {{cod_emitente}} - Grupo Econômico: {{matriz}}
    </v-ons-row>
    <br>
    <v-ons-row>
    <v-ons-col> <span style="font-weight: bold;font-size: 110%">CNPJ </span><br> {{cgc}} </v-ons-col> <v-ons-col> <span style="font-weight: bold;font-size: 110%">Inscrição Estadual </span><br> {{ins_estadual}} </v-ons-col>
    </v-ons-row>
    <br>
    <v-ons-row>
    <v-ons-col> <span style="font-weight: bold;font-size: 110%">Endereço </span><br> {{endereco}}, {{bairro}}. {{cidade}} - {{estado}} </v-ons-col> 
    </v-ons-row>
    <br>
    <v-ons-row>
    <v-ons-col> <span style="font-weight: bold;font-size: 110%">Contato </span> <br> {{email}} <br> {{telefone1}} <br> {{telefone2}}</v-ons-col> 
    </v-ons-row>
    <hr>
    <v-ons-row>
    <v-ons-col> <span style="font-weight: bold;font-size: 110%">Saldo de limite de crédito: {{sdoCred | currency}} </span></v-ons-col> 
    </v-ons-row>
    <br>
    <v-ons-row>
    <v-ons-col> <span style="font-weight: bold;">Limite de Crédito (Total) </span> <br> {{credMatriz['lim-cre-adic'] | currency}} </v-ons-col> 
    <v-ons-col> <span style="font-weight: bold;">Títulos em aberto </span> <br> {{credMatriz['saldo-dev-cr'] | currency}} </v-ons-col>
    </v-ons-row>
    <br>
    <v-ons-row>
    <v-ons-col width="50%"> <span style="font-weight: bold;">Pedidos não aprovados/avaliados </span> <br> {{navalnaprov | currency}} </v-ons-col> 
    <v-ons-col> <span style="font-weight: bold;">Pedidos Aprovados </span> <br> {{credMatriz['tot-ped-aprov-aval'] | currency}} </v-ons-col>
    </v-ons-row>
    <hr>
    <v-ons-row>
    <span style="font-size: 110%; font-weight: bold"> Locais de Entrega </span>
    <v-ons-col width="100%" v-for="item of locEntr"> <br> Código: {{item.codEntrega}} <br> Endereço: {{item.endereco}} <br>{{item.bairro}}, {{item.cidade}} - {{item.estado}} </v-ons-col> 
    </v-ons-row>
    <hr>


    </p>
</div>
 </v-ons-card>
  </v-ons-page>
</template>
<script>

  import { mapGetters } from 'vuex'
  import store from '../store/index.js'
  import local from '../services/sql.js'
  import erp from '../services/erp.js'

export default {
    data(){
    return {
      sFinanc: false,
      sPedido: false,
      sGerais: true,
	  orcamentos: [],
      valSem: '',
      valTot: '',
      valAbe: '',
      locEntr: [],
      titAcr: [],
      titAcrVenc: [],
      titAcrCm: [],
      credMatriz: [],
      Orcamentos: [],
      navalnaprov: '',
      sdoCred: '',
      totSdoVenc: 0,
      totSdoAvenc: 0,
      nome_emit: '',
      cgc: '',
      cod_emitente: '',
      ins_estadual: '',
      cidade: '',
      estado: '',
      bairro: '',
      cep: '',
      endereco: '',
      telefone1: '',
      telefone2: '',
      email: '',
      implant: '',
      bcidade: '',
      bestado: '',
      bbairro: '',
      bcep: '',
      matriz: '',
	    bendereco: '',
      codEntrega: '',
      tpVisao: 'CNPJ'
       }
  },
created() {
erp.detalhe(this.$route.params.id).then(resposta => {
      this.nome_emit = resposta.data['nome-emit']
      this.cgc = resposta.data['cgc']
      this.cod_emitente = resposta.data['cod-emitente']
      this.ins_estadual = resposta.data['ins-estadual']
      this.cidade = resposta.data['cidade']
      this.estado = resposta.data['estado']
      this.bairro = resposta.data['bairro']
      this.cep    = resposta.data['cep']
      this.endereco = resposta.data['endereco']
      this.telefone1 = resposta.data['telefone']['0']
      this.telefone2 = resposta.data['telefone']['1']
      this.email    = resposta.data['e-mail']
      this.implant  = resposta.data['data-implant']
      this.matriz   = resposta.data['nome-matriz']
      erp.endEntrega(resposta.data['nome-abrev']).then(k => {
        if (Array.isArray(k.data)) {
            this.locEntr = k.data
          }
          else {
            this.locEntr = [k.data]
          }
      })
    })
    erp.valores(this.$route.params.id).then(resposta => {
      this.valSem = resposta.data.pedSem
      this.valTot = resposta.data.pedTotal
      this.valAbe = resposta.data.pedAberto
    })
    
    erp.financeiro(this.$route.params.id).then(resposta => {
      this.titAcr = resposta.data
      var d = new Date()

      this.titAcr.forEach(element => {

        var e = new Date(element.datVenc)
        var diffTime = Math.abs(e - d);
        var dif = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        if (d >= e) {
          this.totSdoVenc = this.totSdoVenc + element.sdoTit
          this.titAcrVenc.push({
            codTit: element.codTit,
            codParc: element.codParc,
            datVenc: element.datVenc,
            sdoTit: element.sdoTit,
            dif: dif
          })
        }
        else if (d <= e) {
          this.totSdoAvenc = this.totSdoAvenc + element.sdoTit
          this.titAcrCm.push({
            codTit: element.codTit,
            codParc: element.codParc,
            datVenc: element.datVenc,
            sdoTit: element.sdoTit,
            dif: dif
          })
        }
      });
      
    }),
    erp.filialCredito(this.$route.params.id).then(resposta => {
      this.credMatriz = resposta.data

      this.navalnaprov = Number(((resposta.data['tot-ped-recusados'] -  resposta.data['tot-ped-a-aprovar']).toFixed(2)))

      this.sdoCred = Number(((resposta.data['lim-cre-adic'] + resposta.data['saldo-cred-ap'] - 
       resposta.data['saldo-dev-cr'] - resposta.data['tot-ped-aprov-aval'] - 
       resposta.data['tot-ped-recusados'] -  resposta.data['tot-ped-a-aprovar'] - resposta.data['nfs-atu-cr']).toFixed(2)))
    })
},
methods: {
     orcamento: function () {
        this.$router.push('/orcamento/' + this.cgc + '/1')
      },
}
}
</script>